import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { toast } from '@grandvisionhq/common';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { GET_PLACE_BY_ID } from '../../operations/queries/get-place-by-id.js';
import '../../operations/queries/get-stores-by-distance.js';
import '../../operations/queries/get-store-by-code.js';
import '../../operations/queries/get-store-by-id.js';
import '../../operations/queries/get-store-details.js';
import '../../operations/queries/get-nearest-stores.js';
import '../../operations/queries/get-preferred-store.js';
import '../../operations/queries/get-preferred-store-id.js';
import '../../operations/queries/get-preferred-store-code.js';
import '../../operations/queries/stores-search.js';
import '../../types.js';
import fromPlaceByIdQueryToPlaceById from './adapters/fromPlaceByIdQueryToPlaceById.js';

const usePlaceById = (variables)=>{
    const [query, queryState] = useLazyQuery(GET_PLACE_BY_ID, {
        variables,
        errorPolicy: 'all',
        fetchPolicy: 'no-cache',
        onError (error) {
            toast.failed('stores.page.search.getPlaceById.error');
            console.error('Failed to fetch place by id: ', error);
        }
    });
    return React.useMemo(()=>{
        var ref;
        return [
            query,
            swcHelpers.objectSpread({}, queryState, {
                data: fromPlaceByIdQueryToPlaceById((ref = queryState.data) === null || ref === void 0 ? void 0 : ref.placeById)
            }), 
        ];
    }, [
        query,
        queryState
    ]);
};

export { usePlaceById as default };
//# sourceMappingURL=use-place-by-id.js.map
